import { instanceOfErrorListResponse, Service, type ErrorListResponse } from '@genial/services';
import { useState } from 'react';

import { useToastCreator } from '../../../hooks/useToastCreator';
import {
  errorRequestRedeemSpreadsheetMessage,
  screenName,
  successRequestRedeemSpreadsheetMessage,
} from '../utils/constants';

export const useSpreadsheetDownload = () => {
  const { showToast, showToastFromError } = useToastCreator('toast-request-redeem-spreadsheet');

  const [isPendingSpreadsheetDownload, startIsPendingSpreadsheetDownloadTransition] =
    useState(false);

  const handleRequestRedeemSpreadsheet = async () => {
    try {
      startIsPendingSpreadsheetDownloadTransition(true);
      await Service.Basket.V1.postCreateFile({
        screenName,
        operationType: 'V',
      });
      showToast(...successRequestRedeemSpreadsheetMessage);
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...errorRequestRedeemSpreadsheetMessage);
    } finally {
      startIsPendingSpreadsheetDownloadTransition(false);
    }
  };

  return {
    handleRequestRedeemSpreadsheet,
    isPendingSpreadsheetDownload,
  };
};
